import {
  Text,
  Box,
  VStack,
  CSSObject,
  UnorderedList,
  ListItem,
} from '@chakra-ui/react'

import {} from 'react-icons/fi'

interface Props {
  title: string
  items: string[]
  sx?: CSSObject
}

function CheckListWidget({ title, items, sx }: Props): React.ReactElement {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'stretch',
        flexFlow: 'column nowrap',
        maxW: '543px',
        borderRadius: '12px',
        overflow: 'hidden',
        bg: 'primary.25',
        ...sx,
      }}
    >
      <VStack
        spacing="2"
        sx={{
          alignItems: 'stretch',
          px: { base: 4, md: 8 },
          py: { base: 3, md: 6 },
          flex: '1 1 auto',
        }}
      >
        <Text
          sx={{
            fontSize: {
              base: 'lg',
              sm: '2xl',
            },
            color: 'gray.900',
            fontWeight: 'medium',
          }}
        >
          {title}
        </Text>
        <UnorderedList>
          {items.map((item, index) => {
            return (
              <ListItem
                key={`${index}`}
                sx={{
                  fontSize: {
                    base: 'md',
                    sm: 'lg',
                  },
                  color: 'gray.850',
                  fontWeight: 'light',
                  listStylePosition: 'inside',
                  listStyleType: 'none',
                }}
              >
                &#10003; {item}
              </ListItem>
            )
          })}
        </UnorderedList>
      </VStack>
    </Box>
  )
}

export default CheckListWidget
